"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleBlacklistedDate = void 0;
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
let SimpleBlacklistedDate = class SimpleBlacklistedDate {
    date;
    message;
    description;
    isBlacklistedDate;
    countryIds = [];
    locationIds = [];
};
exports.SimpleBlacklistedDate = SimpleBlacklistedDate;
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsDefined)(),
    (0, type_graphql_1.Field)(),
    __metadata("design:type", Date)
], SimpleBlacklistedDate.prototype, "date", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, type_graphql_1.Field)(),
    __metadata("design:type", String)
], SimpleBlacklistedDate.prototype, "message", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, type_graphql_1.Field)(),
    __metadata("design:type", String)
], SimpleBlacklistedDate.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, type_graphql_1.Field)(),
    __metadata("design:type", Boolean)
], SimpleBlacklistedDate.prototype, "isBlacklistedDate", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, type_graphql_1.Field)(() => [String]),
    __metadata("design:type", Array)
], SimpleBlacklistedDate.prototype, "countryIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, type_graphql_1.Field)(() => [String]),
    __metadata("design:type", Array)
], SimpleBlacklistedDate.prototype, "locationIds", void 0);
exports.SimpleBlacklistedDate = SimpleBlacklistedDate = __decorate([
    (0, type_graphql_1.ObjectType)("SimpleBlacklistedDate"),
    (0, type_graphql_1.InputType)("SimpleBlacklistedDateInput")
], SimpleBlacklistedDate);
//# sourceMappingURL=SimpleBlacklistedDate.js.map